import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export interface PublicContentFilterData {
  status: 'active' | 'archived';
}

@Component({
  selector: 'app-public-content-filter-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonRadio,
    IonRadioGroup,
    IonRow,
    IonTitle,
    IonToolbar,
  ],
  templateUrl: './public-content-filter-modal.component.html',
  styleUrls: ['./public-content-filter-modal.component.scss'],
})
export class PublicContentFilterModalComponent implements OnInit {
  private modalCtrl = inject(ModalController);

  @Input() filters?: PublicContentFilterData | null;
  @Input() title = 'Content Filters';

  status: PublicContentFilterData['status'] = 'active';

  ngOnInit() {
    this.status = this.filters?.status || 'active';
  }

  apply() {
    this.modalCtrl.dismiss({ filters: { status: this.status } satisfies PublicContentFilterData });
  }

  clear() {
    this.modalCtrl.dismiss({ clear: true });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
